var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0166016 24.001V21.001H4.1416L3.5416 20.476C2.2416 19.326 1.3291 18.0135 0.804102 16.5385C0.279102 15.0635 0.0166016 13.576 0.0166016 12.076C0.0166016 9.30098 0.847852 6.83223 2.51035 4.66973C4.17285 2.50723 6.3416 1.07598 9.0166 0.375977V3.52598C7.2166 4.17598 5.7666 5.28223 4.6666 6.84473C3.5666 8.40723 3.0166 10.151 3.0166 12.076C3.0166 13.201 3.2291 14.2947 3.6541 15.3572C4.0791 16.4197 4.7416 17.401 5.6416 18.301L6.0166 18.676V15.001H9.0166V24.001H0.0166016ZM15.0166 23.626V20.476C16.8166 19.826 18.2666 18.7197 19.3666 17.1572C20.4666 15.5947 21.0166 13.851 21.0166 11.926C21.0166 10.801 20.8041 9.70723 20.3791 8.64473C19.9541 7.58223 19.2916 6.60098 18.3916 5.70098L18.0166 5.32598V9.00098H15.0166V0.000976562H24.0166V3.00098H19.8916L20.4916 3.52598C21.7166 4.75098 22.6104 6.08223 23.1729 7.51973C23.7354 8.95723 24.0166 10.426 24.0166 11.926C24.0166 14.701 23.1854 17.1697 21.5229 19.3322C19.8604 21.4947 17.6916 22.926 15.0166 23.626Z",
    fill: "#004EA8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.746c1f03f11d579f5b774f56f8718a1b.svg";
export { ForwardRef as ReactComponent };